import { ref } from "vue";
import { useAppState } from "../Stores/AppState";
import { ROUTE_NAMES } from "../Constants/routes";
import { useUnlinkedPanelState } from "../Stores/useUnlinkedPanelState";

// Default value for snackbar
const snackbar = ref({
    title: "",
    message: "Lorem ipsum dolor sit amet consectetur!",
    visible: false,
    timeout: 3000,
    color: "success",
    location: "bottom",
    avatar_url: null,
    button_text: null,
    button_url: null,
    on_click: null,
});

const requestSnackbar = ref({
    title: "",
    message: "Lorem ipsum dolor sit amet consectetur!",
    visible: false,
    timeout: 3000,
    color: "var(--v-theme-success)",
    location: "bottom",
    icon: {
        name: "priority_high",
        color: "rgb(var(--v-theme-success))",
        activeClass: "prospus-attention-request-snackbar--icon",
    },
});

const assignmentSnakebar = ref({
    title: "",
    message: "Lorem ipsum dolor sit amet consectetur!",
    visible: false,
    timeout: 3000,
    color: "success",
    location: "bottom",
});

const snackbars = ref([]);

const activePanel = ref(1);

const chatPopover = ref(false);

const activeChatData = ref({
    visible: false,
    data: {},
});

const activeEditorData = ref({
    visible: false,
    data: {},
});

const selectedPanelItem = ref(null);

const activity_details = ref();

const snackbar_clicked_outside = ref(false);

export default function utilities() {
    const app_state_store = useAppState();
    const unlinkedPanelState = useUnlinkedPanelState();

    function setActivePanel(panel) {
        activePanel.value = panel;
    }

    function setChatData(obj) {
        activeChatData.value.visible =
            obj?.visible || activeChatData.value.visible;
        activeChatData.value.data = obj?.data || activeChatData.value.data;
    }

    function toggleChat() {
        if (activeChatData.value.visible) {
            activeChatData.value.data = {};
        }
        activeChatData.value.visible = !activeChatData.value.visible;
    }

    function isEditorOpen() {
        return activeEditorData.value.visible;
    }

    function toggleChatOff() {
        activeEditorData.value.visible = false;
    }

    function setTextEditor(obj) {
        activeEditorData.value.visible =
            obj?.visible || activeEditorData.value.visible;
        activeEditorData.value.data = obj?.data || activeEditorData.value.data;
    }

    function toggleTextEditor() {
        if (activeEditorData.value.visible) {
            activeEditorData.value.data = {};
        }
        activeEditorData.value.visible = !activeEditorData.value.visible;
    }

    function toggleTextEditorOff() {
        activeEditorData.value.visible = false;
    }

    function setSelectedPanelItem(obj) {
        selectedPanelItem.value = obj;
        activeChatData.value.data = obj;
    }

    function toggleChatPopover(
        value = null,
        close_details = true,
        autoOpenWorkPanel = false,
    ) {
        const { is_work, is_activity, is_team } = app_state_store;
        chatPopover.value = value === null ? !chatPopover.value : value;
        if (
            chatPopover.value &&
            !(is_work || is_activity || is_team) &&
            !autoOpenWorkPanel
        ) {
            unlinkedPanelState.switchToLastDetachChatRouteFromUnlinkedPanel();
        }

        activeChatData.value.visible =
            value === null ? !chatPopover.value : value;
        app_state_store.updateConversationState(chatPopover.value);

        if (!value || close_details) {
            // app_state_store.toggleActivityDetails(false)
        }
    }

    function toggleChatPopoverWithoutUpdatingState(
        value = null,
        close_details = true,
    ) {
        chatPopover.value = value === null ? !chatPopover.value : value;
        activeChatData.value.visible =
            value === null ? !chatPopover.value : value;
        this.is_conversation_open = chatPopover.value;
    }

    function setSnackbar(obj) {
        snackbar.value.title = obj?.title || "";
        snackbar.value.message = obj?.message || "";
        snackbar.value.visible = obj?.visible || snackbar.value.visible;
        snackbar.value.timeout = obj?.timeout || snackbar.value.timeout;
        snackbar.value.color = obj?.color || snackbar.value.color;
        snackbar.value.location = obj?.location || snackbar.value.location;
        snackbar.value.avatar_url = obj?.avatar_url || null;
        snackbar.value.button_text = obj?.button_text || null;
        snackbar.value.button_url = obj?.button_url || null;
        snackbar.value.icon = obj?.icon || snackbar.value.icon;
        snackbar.value.class = obj?.class || snackbar.value.class;
        snackbar.value.on_click =
            obj?.on_click !== undefined ? obj.on_click : null;
    }

    function toggleSnackBarOff() {
        snackbar.value.visible = false;
    }

    function toggleSnackBarOn() {
        snackbar.value.visible = true;
    }

    function toggleSnackBar(obj) {
        snackbar.value.visible = false;

        let to = setTimeout(() => {
            snackbar.value.title = obj?.title || "";
            snackbar.value.message = obj?.message || "";
            snackbar.value.timeout = obj?.timeout || snackbar.value.timeout;
            snackbar.value.color = obj?.color || snackbar.value.color;
            snackbar.value.location = obj?.location || snackbar.value.location;
            snackbar.value.avatar_url = obj?.avatar_url;
            snackbar.value.button_text = obj?.button_text;
            snackbar.value.button_url = obj?.button_url;
            snackbar.value.visible = true;
            snackbar.value.icon = obj?.icon || snackbar.value.icon;
            snackbar.value.class = obj?.class || snackbar.value.class;
            clearTimeout(to);
        }, 50);
    }

    function toggleRequestSnackBarOff() {
        requestSnackbar.value.visible = false;
    }

    function toggleRequestSnackBarOn() {
        requestSnackbar.value.visible = true;
    }

    function toggleRequestSnackBar(obj) {
        requestSnackbar.value.visible = false;
        let timeout = setTimeout(() => {
            requestSnackbar.value.title = obj?.title || "";
            requestSnackbar.value.message = obj?.message || "";
            requestSnackbar.value.timeout =
                obj?.timeout || requestSnackbar.value.timeout;
            requestSnackbar.value.color =
                obj?.color || requestSnackbar.value.color;
            requestSnackbar.value.location =
                obj?.location || requestSnackbar.value.location;
            requestSnackbar.value.icon =
                obj?.icon || requestSnackbar.value.icon;
            requestSnackbar.value.class =
                obj?.class || requestSnackbar.value.class;
            requestSnackbar.value.visible = true;
            clearTimeout(timeout);
        }, 50);
    }

    function showSnackbar(
        message,
        type,
        avatar_url = null,
        timeout = 3000,
        button_text = null,
        button_url = null,
        on_click = null,
    ) {
        toggleSnackBarOff();
        setSnackbar({
            message: message,
            visible: false,
            timeout: timeout,
            color: type,
            location: "bottom center",
            avatar_url: avatar_url,
            button_text: button_text,
            button_url: button_url,
            on_click: on_click,
        });
        toggleSnackBarOn();
    }

    function showStackedSnackbar(
        message,
        type,
        avatar_url = null,
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        addSnackbar({
            message: message,
            timeout: timeout,
            color: type,
            avatar_url: avatar_url,
            button_text: button_text,
            button_url: button_url,
        });
    }

    function addSnackbar(obj) {
        snackbars.value.push({
            title: obj?.title || "",
            message: obj?.message || "",
            visible: true,
            timeout: obj?.timeout || 3000,
            color: obj?.color || "info",
            location: obj?.location || "bottom right",
            avatar_url: obj?.avatar_url || null,
            button_text: obj?.button_text || null,
            button_url: obj?.button_url || null,
            icon: obj?.icon || null,
        });
    }

    function showSuccessSnackbar(
        message,
        avatar_url = null,
        type = "success",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function showErrorSnackbar(
        message,
        avatar_url = null,
        type = "error",
        timeout = 3000,
        button_text = null,
        button_url = null,
        on_click = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
            on_click,
        );
    }

    function showInfoSnackbar(
        message,
        avatar_url = null,
        type = "info",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function showInteractiveSnackbar(
        message,
        avatar_url = null,
        type = "info",
        timeout = 3000,
        button_text = null,
        button_url = null,
    ) {
        showStackedSnackbar(
            message,
            type,
            avatar_url,
            timeout,
            button_text,
            button_url,
        );
    }

    function setAssignmentSnackbar(obj) {
        assignmentSnakebar.value.title = obj?.title || "";
        assignmentSnakebar.value.message = obj?.message || "";
        assignmentSnakebar.value.visible =
            obj?.visible || snackbar.value.visible;
        assignmentSnakebar.value.timeout =
            obj?.timeout || snackbar.value.timeout;
        assignmentSnakebar.value.color = obj?.color || snackbar.value.color;
        assignmentSnakebar.value.location =
            obj?.location || snackbar.value.location;
        assignmentSnakebar.value.icon = obj?.icon || snackbar.value.icon;
        assignmentSnakebar.value.class = obj?.class || snackbar.value.class;
    }
    function showAssignmentSnackbar(message, type, timeout = 3000) {
        assignmentSnakebar.value.visible = false;
        setAssignmentSnackbar({
            message: message,
            visible: false,
            timeout: timeout,
            color: type,
            location: "bottom right",
        });
        assignmentSnakebar.value.visible = true;
    }

    function showAssignmentSuccessSnackbar(
        message,
        type = "success",
        timeout = 3000,
    ) {
        showAssignmentSnackbar(message, type, timeout);
    }

    function copyToClipboard(message) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(message);
            return;
        }
        const body = document.querySelector("body");
        const area = document.createElement("textarea");
        area.style.height = "0";
        body.appendChild(area);

        area.value = message;
        area.select();
        document.execCommand("copy");
        body.removeChild(area);
    }

    function convertMinutesToHoursAndMinutes(total_minutes) {
        const hours = Math.floor(total_minutes / 60);
        const minutes = total_minutes % 60;
        return { hours, minutes };
    }

    function calculateDayProgress(total_minutes) {
        const minutesInADay = 8 * 60;
        return (total_minutes / minutesInADay) * 100;
    }

    function setSnackbarClickedOutside() {
        snackbar_clicked_outside.value = true;
    }

    function getFileNameFromResponse(response) {
        if (response.headers.hasOwnProperty("content-disposition")) {
            const content_disposition = response.headers["content-disposition"];
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
                content_disposition,
            );
            if (matches && matches.length > 1) {
                return matches[1].replace(/['"]/g, "");
            }
        }
        return null;
    }

    function downloadFileFromResponse(response, name = null) {
        let blob = new Blob([response.data], {
            type: response.headers["content-type"],
        });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = name || getFileNameFromResponse(response);
        link.click();
    }

    function getTimeDifference(future_date, now, indications = true) {
        if (future_date < now) {
            return ":00";
        }

        const diff_ms = Math.abs(future_date - now);

        const diff_hours = Math.floor(diff_ms / (1000 * 60 * 60));
        const diff_minutes = Math.floor(
            (diff_ms % (1000 * 60 * 60)) / (1000 * 60),
        );

        let result = "";

        if (indications) {
            if (diff_hours > 0) {
                result = `${diff_hours}h`;
            }
            if (diff_minutes > 0) {
                result += ` ${diff_minutes}m`;
            }
        } else {
            const mins = diff_minutes.toString();
            if (diff_hours > 0) {
                result += `${diff_hours}`;
            }
            result += `:${mins.padStart(2, "0")}`;
        }

        return result;
    }

    function handleError(
        error,
        show_error_toast = true,
        expectation_object = null,
    ) {
        if (
            error?.response?.status === expectation_object?.status &&
            expectation_object?.callback
        ) {
            return expectation_object?.callback?.(error);
        }

        if (error.code === "ERR_NETWORK") {
            console.error(
                "🚨 Network error! Check your internet or server status.",
            );
        } else if (error.code === "ECONNABORTED") {
            console.error(
                "⏳ Request timed out! The server is taking too long to respond.",
            );
        } else if (error.response) {
            if (error?.response?.data?.message && show_error_toast) {
                showErrorSnackbar(error?.response?.data?.message);
            }
            console.error(
                `❌ HTTP Error: ${error.response.status} - ${error.response.statusText}`,
                error?.response?.data,
            );
        } else {
            console.error("Request Error: ", error);
        }
    }
    function generateVideoThumbnail(videoUrl, timeInSeconds = 1) {
        return new Promise((resolve, reject) => {
            const video = document.createElement("video");

            video.crossOrigin = "anonymous"; // important for external URLs

            video.src = videoUrl;

            video.muted = true;

            video.playsInline = true;

            video.addEventListener("loadedmetadata", () => {
                // Clamp time if video is shorter

                const captureTime = Math.min(timeInSeconds, video.duration);

                video.currentTime = captureTime;
            });

            video.addEventListener("seeked", () => {
                const canvas = document.createElement("canvas");

                canvas.width = video.videoWidth;

                canvas.height = video.videoHeight;

                const ctx = canvas.getContext("2d");

                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const thumbnailUrl = canvas.toDataURL("image/png");

                // Cleanup

                video.remove();

                canvas.remove();

                resolve(thumbnailUrl);
            });

            video.addEventListener("error", (err) => {
                console.error("Failed to load video", err);
                reject("Failed to load video");
            });
        });
    }

    return {
        // States
        snackbar,
        snackbars,
        chatPopover,
        selectedPanelItem,
        activeEditorData,
        activePanel,
        activeChatData,
        snackbar_clicked_outside,
        assignmentSnakebar,
        requestSnackbar,

        // Functions
        toggleChatPopover,
        toggleChatPopoverWithoutUpdatingState,
        setSnackbar,
        toggleSnackBarOff,
        toggleSnackBarOn,
        toggleSnackBar,
        toggleRequestSnackBarOff,
        toggleRequestSnackBar,
        toggleRequestSnackBarOn,
        showInteractiveSnackbar,
        showSuccessSnackbar,
        showInfoSnackbar,
        showErrorSnackbar,
        setSelectedPanelItem,
        setTextEditor,
        toggleTextEditor,
        toggleTextEditorOff,
        setActivePanel,
        toggleChat,
        setChatData,
        toggleChatOff,
        isEditorOpen,
        copyToClipboard,
        convertMinutesToHoursAndMinutes,
        calculateDayProgress,
        setSnackbarClickedOutside,
        getFileNameFromResponse,
        downloadFileFromResponse,
        getTimeDifference,
        showAssignmentSuccessSnackbar,
        handleError,
        generateVideoThumbnail,
    };
}
